// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from "./core/CancelablePromise";
import { OpenAPI } from "./core/OpenAPI";
import { request as __request } from "./core/request";
import type {
  BdxPerilBreakdownData,
  BdxPerilBreakdownResponse,
  CreateBorLetterEndpointData,
  CreateBorLetterEndpointResponse,
  GetBorLetterEndpointData,
  GetBorLetterEndpointResponse,
  GetBorLettersByReportEndpointData,
  GetBorLettersByReportEndpointResponse,
  ListBorLettersEndpointData,
  ListBorLettersEndpointResponse,
  MarkBorStepEndpointData,
  MarkBorStepEndpointResponse,
  BorEmailPreviewEndpointData,
  BorEmailPreviewEndpointResponse,
  BorSendEmailEndpointData,
  BorSendEmailEndpointResponse,
  ListContactsEndpointResponse,
  CreateContactEndpointData,
  CreateContactEndpointResponse,
  UpdateContactEndpointData,
  UpdateContactEndpointResponse,
  BrokerAnalyticsData,
  BrokerAnalyticsResponse,
  CrmBrokerExportResponse,
  GetSubmissionStatusCountsResponse,
  GetPolicyflyApplicationsData,
  GetPolicyflyApplicationsResponse,
  AsgardListReportActionLogsData,
  AsgardListReportActionLogsResponse,
  AsgardGetReportActionLogData,
  AsgardGetReportActionLogResponse,
  PrecheckData,
  PrecheckResponse2,
  DownloadCatArtifactData,
  DownloadCatArtifactResponse,
  DownloadAllCatArtifactsZipData,
  DownloadAllCatArtifactsZipResponse,
  GetCatJobHistoryData,
  GetCatJobHistoryResponse,
  GetLayerPmiData,
  GetLayerPmiResponse,
  GetCatResultsData,
  GetCatResultsResponse,
  RunCatModelData,
  RunCatModelResponse,
  CatRunStatusesData,
  CatRunStatusesResponse,
  ResumeCatPipelineData,
  ResumeCatPipelineResponse,
  RerunCatFinancialData,
  RerunCatFinancialResponse,
  ActivateCatBatchData,
  ActivateCatBatchResponse,
  GetVendorEnrichmentData,
  GetVendorEnrichmentResponse,
  SetVendorEnrichmentData,
  SetVendorEnrichmentResponse,
  GetDeductibleSummaryData,
  GetDeductibleSummaryResponse,
  AsgardRunFixSovData,
  AsgardRunFixSovResponse,
  AsgardSetFunctionInstructionsData,
  AsgardSetFunctionInstructionsResponse,
  AsgardListClearanceMetadataData,
  AsgardListClearanceMetadataResponse,
  AsgardIngestEmailData,
  AsgardIngestEmailResponse,
  InitiateCapeRequestData,
  InitiateCapeRequestResponse,
  CapeRequestStatusData,
  CapeRequestStatusResponse,
  GetCapeJobHistoryData,
  GetCapeJobHistoryResponse,
  EnqueueReplacementCostData,
  EnqueueReplacementCostResponse,
  GetIntegrationDataData,
  GetIntegrationDataResponse,
  GetFinancialModelAuditData,
  GetFinancialModelAuditResponse,
  BulkEnrichSubmissionsData,
  BulkEnrichSubmissionsResponse,
  GetLimitSummaryData,
  GetLimitSummaryResponse,
  GetLayerGateExposureData,
  GetLayerGateExposureResponse,
  GetGateTrackingBaseData,
  GetGateTrackingBaseResponse,
  GetPortfolioGateAccumulationResponse,
  GetAalPremiumGatePortfolioResponse,
  GetAalPremiumGateTrackingData,
  GetAalPremiumGateTrackingResponse,
  StandardFormattingData,
  StandardFormattingResponse,
  InitiateNearmapRequestData,
  InitiateNearmapRequestResponse,
  NearmapRequestStatusData,
  NearmapRequestStatusResponse,
  GetNearmapJobHistoryData,
  GetNearmapJobHistoryResponse,
  PeriodicHourlyResponse,
  PeriodicNightlyResponse,
  PeriodicEvery5MResponse,
  CalculatePremiumData,
  CalculatePremiumResponse,
  GetResolvedPremiumsData,
  GetResolvedPremiumsResponse,
  ReconcilePolicyflyResponse,
  DownloadRaterWorkbookData,
  DownloadRaterWorkbookResponse,
  GetRateComponentsData,
  GetRateComponentsResponse,
  GetEqbdRaterResultsData,
  GetEqbdRaterResultsResponse,
  GetBookSummaryData,
  GetBookSummaryResponse,
  GetSubmissionAnalyticsResponse,
  GetExposureMapSummaryData,
  GetExposureMapSummaryResponse,
  GetExposureMapLocationsData,
  GetExposureMapLocationsResponse,
  GetAreaExposureData,
  GetAreaExposureResponse,
  GetPolicyFootprintData,
  GetPolicyFootprintResponse,
  GetActiveStormsResponse,
  GetPastStormsResponse,
  GetLocationClassificationsData,
  GetLocationClassificationsResponse,
  AsgardCreatePolicyApplicationsData,
  AsgardCreatePolicyApplicationsResponse,
  AsgardListPolicyApplicationsData,
  AsgardListPolicyApplicationsResponse,
  AsgardPolicyApplicationFieldsData,
  AsgardPolicyApplicationFieldsResponse,
  AsgardUpdatePolicyOverlayData,
  AsgardUpdatePolicyOverlayResponse,
  AsgardUpdatePolicyApplicationData,
  AsgardUpdatePolicyApplicationResponse,
  AsgardPolicyApplicationFormsData,
  AsgardPolicyApplicationFormsResponse,
  AsgardUpdateApplicationFormData,
  AsgardUpdateApplicationFormResponse,
  AsgardApplicationQuoteTemplateData,
  AsgardApplicationQuoteTemplateResponse,
  AsgardSaveApplicationQuoteTemplateData,
  AsgardSaveApplicationQuoteTemplateResponse,
  AsgardResetApplicationQuoteTemplateData,
  AsgardResetApplicationQuoteTemplateResponse,
  AsgardApplicationQuoteUnknownsData,
  AsgardApplicationQuoteUnknownsResponse,
  AsgardGenerateApplicationQuoteData,
  AsgardGenerateApplicationQuoteResponse,
  AsgardListEndorsementsData,
  AsgardListEndorsementsResponse,
  AsgardCreateEndorsementData,
  AsgardCreateEndorsementResponse,
  AsgardUploadEndorsementDocumentsData,
  AsgardUploadEndorsementDocumentsResponse,
  AsgardSuggestEndorsementPremiumData,
  AsgardSuggestEndorsementPremiumResponse,
  AsgardEstimateEndorsementPremiumData,
  AsgardEstimateEndorsementPremiumResponse,
  AsgardUpdateEndorsementPremiumData,
  AsgardUpdateEndorsementPremiumResponse,
  AsgardUpdateEndorsementStatusData,
  AsgardUpdateEndorsementStatusResponse,
  AsgardDeleteEndorsementData,
  AsgardDeleteEndorsementResponse,
  AsgardEndorsementSovDiffData,
  AsgardEndorsementSovDiffResponse,
  AsgardRegenerateEndorsementData,
  AsgardRegenerateEndorsementResponse,
  HealthcheckResponse,
  LoginData,
  LoginResponse2,
  ListUsersResponse,
  LogEventData,
  LogEventResponse,
  AsgardListReportsPostData,
  AsgardListReportsPostResponse,
  AsgardListReportData,
  AsgardListReportResponse,
  AsgardFreshnessData,
  AsgardFreshnessResponse,
  AsgardGoogleGroupStatsData,
  AsgardGoogleGroupStatsResponse,
  AsgardEmailThreadsData,
  AsgardEmailThreadsResponse,
  AsgardDeleteEmailThreadData,
  AsgardDeleteEmailThreadResponse,
  AsgardDownloadThreadAttachmentData,
  AsgardDownloadThreadAttachmentResponse,
  AsgardGenerateUnderwritingPdfData,
  AsgardGenerateUnderwritingPdfResponse,
  AsgardQuoteIndicationPreflightData,
  AsgardQuoteIndicationPreflightResponse,
  AsgardGenerateQuoteIndicationDraftData,
  AsgardGenerateQuoteIndicationDraftResponse,
  AsgardQuoteIndicationHtmlData,
  AsgardQuoteIndicationHtmlResponse,
  AsgardGenerateReferralDraftData,
  AsgardGenerateReferralDraftResponse,
  AsgardDownloadLossRunData,
  AsgardDownloadLossRunResponse,
  AsgardUpdateReportData,
  AsgardUpdateReportResponse,
  AsgardAddManualAddressData,
  AsgardAddManualAddressResponse,
  AsgardBatchCommentsData,
  AsgardBatchCommentsResponse,
  AsgardAddCommentData,
  AsgardAddCommentResponse,
  AsgardDeleteCommentData,
  AsgardDeleteCommentResponse,
  AsgardEditCommentData,
  AsgardEditCommentResponse,
  AsgardDeleteReportData,
  AsgardDeleteReportResponse,
  AsgardUpdateAddressData,
  AsgardUpdateAddressResponse,
  AsgardListAdditionalFilesData,
  AsgardListAdditionalFilesResponse,
  AsgardDeleteAdditionalFilesData,
  AsgardDeleteAdditionalFilesResponse,
  AsgardDeleteAttachmentData,
  AsgardDeleteAttachmentResponse,
  AsgardTestPythonFunctionData,
  AsgardTestPythonFunctionResponse,
  AsgardUploadAdditionalFileData,
  AsgardUploadAdditionalFileResponse,
  AsgardRerunOptionsData,
  AsgardRerunOptionsResponse,
  AsgardUploadEmailThreadData,
  AsgardUploadEmailThreadResponse,
  AsgardClassifyStagedAttachmentData,
  AsgardClassifyStagedAttachmentResponse,
  AsgardExtractStagedAttachmentsData,
  AsgardExtractStagedAttachmentsResponse,
  AsgardDownloadAdditionalFileData,
  AsgardDownloadAdditionalFileResponse,
  GenerateBulkEditData,
  GenerateBulkEditResponse,
  DownloadReportFileData,
  DownloadReportFileResponse,
  CspReportResponse,
  AsgardListSavedFiltersResponse,
  AsgardDeleteSavedFilterData,
  AsgardDeleteSavedFilterResponse,
  AsgardUpdateSavedFilterData,
  AsgardUpdateSavedFilterResponse,
  AsgardAddSavedFilterData,
  AsgardAddSavedFilterResponse,
  AsgardLoadAddressesForMapData,
  AsgardLoadAddressesForMapResponse,
  AsgardLoadAddressesData,
  AsgardLoadAddressesResponse,
  AsgardEmlPreviewData,
  AsgardEmlPreviewResponse,
  AsgardDownloadReportHistoryData,
  AsgardDownloadReportHistoryResponse,
  AsgardListUpdatingReportsData,
  AsgardListUpdatingReportsResponse,
  AsgardListReportJobsData,
  AsgardListReportJobsResponse,
  AsgardCancelJobData,
  AsgardCancelJobResponse,
  AsgardSetBatchPriorityData,
  AsgardSetBatchPriorityResponse,
  AsgardListTemplatesResponse,
  AsgardDeleteTemplateData,
  AsgardDeleteTemplateResponse,
  AsgardUpdateTemplateData,
  AsgardUpdateTemplateResponse,
  AsgardCreateTemplateData,
  AsgardCreateTemplateResponse,
  AsgardDownloadTemplateData,
  AsgardDownloadTemplateResponse,
  AsgardGeneratePolicyNumbersData,
  AsgardGeneratePolicyNumbersResponse,
  AsgardGeneratePolicyFlyApplicationData,
  AsgardGeneratePolicyFlyApplicationResponse,
  AsgardUpdatePolicyFlyApplicationData,
  AsgardUpdatePolicyFlyApplicationResponse,
  AsgardLinkPolicyFlyApplicationData,
  AsgardLinkPolicyFlyApplicationResponse,
  AsgardUnlinkPolicyFlyApplicationData,
  AsgardUnlinkPolicyFlyApplicationResponse,
  AsgardClearanceEmailRecipientsData,
  AsgardClearanceEmailRecipientsResponse,
  AsgardSendClearanceEmailData,
  AsgardSendClearanceEmailResponse,
} from "./types.gen";

/**
 * Bdx Peril Breakdown
 * Append per-peril premium allocation columns to an uploaded BDX.
 *
 * The reinsurer is detected from the uploaded filename and its participation
 * percentage is applied when validating each row's premium. Any row that
 * can't be matched (or whose premium disagrees with ours) fails the whole
 * request with a human-readable 400 detail. Rows accepted without validation
 * (Additional and Return Premium endorsements) are reported per-row in the
 * response metadata header (``BdxPerilBreakdownMeta``).
 * @param data The data for the request.
 * @param data.formData
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const bdxPerilBreakdown = (
  data: BdxPerilBreakdownData
): CancelablePromise<BdxPerilBreakdownResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/bdx/peril_breakdown",
    formData: data.formData,
    mediaType: "multipart/form-data",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Create Bor Letter Endpoint
 * @param data The data for the request.
 * @param data.requestBody
 * @returns BorLetterResponse Successful Response
 * @throws ApiError
 */
export const createBorLetterEndpoint = (
  data: CreateBorLetterEndpointData
): CancelablePromise<CreateBorLetterEndpointResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/bor/create",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Bor Letter Endpoint
 * @param data The data for the request.
 * @param data.requestBody
 * @returns BorLetterResponse Successful Response
 * @throws ApiError
 */
export const getBorLetterEndpoint = (
  data: GetBorLetterEndpointData
): CancelablePromise<GetBorLetterEndpointResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/bor/get",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Bor Letters By Report Endpoint
 * @param data The data for the request.
 * @param data.requestBody
 * @returns BorLetterListResponse Successful Response
 * @throws ApiError
 */
export const getBorLettersByReportEndpoint = (
  data: GetBorLettersByReportEndpointData
): CancelablePromise<GetBorLettersByReportEndpointResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/bor/by_report",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * List Bor Letters Endpoint
 * @param data The data for the request.
 * @param data.requestBody
 * @returns BorLetterListResponse Successful Response
 * @throws ApiError
 */
export const listBorLettersEndpoint = (
  data: ListBorLettersEndpointData
): CancelablePromise<ListBorLettersEndpointResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/bor/list",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Mark Bor Step Endpoint
 * @param data The data for the request.
 * @param data.requestBody
 * @returns BorLetterResponse Successful Response
 * @throws ApiError
 */
export const markBorStepEndpoint = (
  data: MarkBorStepEndpointData
): CancelablePromise<MarkBorStepEndpointResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/bor/mark_step",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Bor Email Preview Endpoint
 * Render the email a step will send (subject, body, recipients) without
 * sending it, for the confirmation modal.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns RenderedBorEmail Successful Response
 * @throws ApiError
 */
export const borEmailPreviewEndpoint = (
  data: BorEmailPreviewEndpointData
): CancelablePromise<BorEmailPreviewEndpointResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/bor/email_preview",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Bor Send Email Endpoint
 * Send the broker email for a step, record it on the BOR letter, and mark
 * the step done if it isn't already. Re-sending an already-sent step's email
 * is allowed (e.g. after an earlier skip) and does not re-mark the step.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns BorLetterResponse Successful Response
 * @throws ApiError
 */
export const borSendEmailEndpoint = (
  data: BorSendEmailEndpointData
): CancelablePromise<BorSendEmailEndpointResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/bor/send_email",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * List Contacts Endpoint
 * List all contacts for the current user's client.
 * @returns ListContactsResponse Successful Response
 * @throws ApiError
 */
export const listContactsEndpoint =
  (): CancelablePromise<ListContactsEndpointResponse> => {
    return __request(OpenAPI, {
      method: "GET",
      url: "/crm/contacts",
    });
  };

/**
 * Create Contact Endpoint
 * Create a new contact.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns CreateContactResponse Successful Response
 * @throws ApiError
 */
export const createContactEndpoint = (
  data: CreateContactEndpointData
): CancelablePromise<CreateContactEndpointResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/crm/contact",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Update Contact Endpoint
 * Update a contact's information.
 * @param data The data for the request.
 * @param data.contactId
 * @param data.requestBody
 * @returns UpdateContactResponse Successful Response
 * @throws ApiError
 */
export const updateContactEndpoint = (
  data: UpdateContactEndpointData
): CancelablePromise<UpdateContactEndpointResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/crm/contact/{contact_id}",
    path: {
      contact_id: data.contactId,
    },
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Broker Analytics
 * Returns a variety of broker-related analytics based on the selected date range and report type.
 * @param data The data for the request.
 * @param data.dateChoice
 * @param data.reportSelection
 * @returns GetBrokerAnalyticsResponse Successful Response
 * @throws ApiError
 */
export const brokerAnalytics = (
  data: BrokerAnalyticsData
): CancelablePromise<BrokerAnalyticsResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/crm/broker_analytics",
    query: {
      date_choice: data.dateChoice,
      report_selection: data.reportSelection,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Crm Broker Export
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const crmBrokerExport =
  (): CancelablePromise<CrmBrokerExportResponse> => {
    return __request(OpenAPI, {
      method: "POST",
      url: "/crm/broker_export",
    });
  };

/**
 * Get Submission Status Counts
 * @returns SubmissionStatusCountsResponse Successful Response
 * @throws ApiError
 */
export const getSubmissionStatusCounts =
  (): CancelablePromise<GetSubmissionStatusCountsResponse> => {
    return __request(OpenAPI, {
      method: "GET",
      url: "/crm/submission_status_counts",
    });
  };

/**
 * Get Policyfly Applications
 * @param data The data for the request.
 * @param data.statuses
 * @returns ListPolicyFlyApplicationsResponse Successful Response
 * @throws ApiError
 */
export const getPolicyflyApplications = (
  data: GetPolicyflyApplicationsData
): CancelablePromise<GetPolicyflyApplicationsResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/crm/policyfly_applications",
    query: {
      statuses: data.statuses,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard List Report Action Logs
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ListReportActionLogsResponse Successful Response
 * @throws ApiError
 */
export const asgardListReportActionLogs = (
  data: AsgardListReportActionLogsData
): CancelablePromise<AsgardListReportActionLogsResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/list_report_action_logs",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Get Report Action Log
 * @param data The data for the request.
 * @param data.requestBody
 * @returns GetReportActionLogResponse Successful Response
 * @throws ApiError
 */
export const asgardGetReportActionLog = (
  data: AsgardGetReportActionLogData
): CancelablePromise<AsgardGetReportActionLogResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/get_report_action_log",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Precheck
 * @param data The data for the request.
 * @param data.reportId
 * @returns PrecheckResponse Successful Response
 * @throws ApiError
 */
export const precheck = (
  data: PrecheckData
): CancelablePromise<PrecheckResponse2> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/precheck/{report_id}",
    path: {
      report_id: data.reportId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Download Cat Artifact
 * @param data The data for the request.
 * @param data.reportId
 * @param data.batchId
 * @param data.type Integration type: icm or rms
 * @param data.artifact Artifact prefix to download
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const downloadCatArtifact = (
  data: DownloadCatArtifactData
): CancelablePromise<DownloadCatArtifactResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/cat/download/{report_id}/{batch_id}",
    path: {
      report_id: data.reportId,
      batch_id: data.batchId,
    },
    query: {
      type: data.type,
      artifact: data.artifact,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Download All Cat Artifacts Zip
 * @param data The data for the request.
 * @param data.reportId
 * @param data.batchId
 * @param data.type Integration type: icm or rms
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const downloadAllCatArtifactsZip = (
  data: DownloadAllCatArtifactsZipData
): CancelablePromise<DownloadAllCatArtifactsZipResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/cat/download_all/{report_id}/{batch_id}",
    path: {
      report_id: data.reportId,
      batch_id: data.batchId,
    },
    query: {
      type: data.type,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Cat Job History
 * @param data The data for the request.
 * @param data.reportId
 * @param data.type Integration type: icm or rms.
 * @returns CatJobHistoryResponse Successful Response
 * @throws ApiError
 */
export const getCatJobHistory = (
  data: GetCatJobHistoryData
): CancelablePromise<GetCatJobHistoryResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/cat/job_history/{report_id}",
    path: {
      report_id: data.reportId,
    },
    query: {
      type: data.type,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Layer Pmi
 * Compute this layer's per-peril PMI at ``share`` (fraction of the
 * layer) from the stored vector artifacts. Interactive path — nothing
 * is persisted.
 * @param data The data for the request.
 * @param data.reportId
 * @param data.layerId
 * @param data.share
 * @returns LayerPmiResponse Successful Response
 * @throws ApiError
 */
export const getLayerPmi = (
  data: GetLayerPmiData
): CancelablePromise<GetLayerPmiResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/cat/pmi/{report_id}/{layer_id}",
    path: {
      report_id: data.reportId,
      layer_id: data.layerId,
    },
    query: {
      share: data.share,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Cat Results
 * @param data The data for the request.
 * @param data.reportId
 * @param data.batchId
 * @returns CatResultsResponse Successful Response
 * @throws ApiError
 */
export const getCatResults = (
  data: GetCatResultsData
): CancelablePromise<GetCatResultsResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/cat/results/{report_id}",
    path: {
      report_id: data.reportId,
    },
    query: {
      batch_id: data.batchId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Run Cat Model
 * Start every run in ``request.runs`` (CAT vendors and raters) on the report.
 * Not atomic: each run starts independently and gets its own outcome, so one
 * that is refused, in flight or failed doesn't stop the others. A CAT baseline
 * run (activated) does the least work to make results current under its
 * enrichment source; shadow runs always model in full. A run under a vendor
 * source fetches that source's data first when the report lacks it.
 * @param data The data for the request.
 * @param data.reportId
 * @param data.requestBody
 * @returns CatRunResult Successful Response
 * @throws ApiError
 */
export const runCatModel = (
  data: RunCatModelData
): CancelablePromise<RunCatModelResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/cat/{report_id}/run",
    path: {
      report_id: data.reportId,
    },
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Cat Run Statuses
 * @param data The data for the request.
 * @param data.requestBody
 * @returns CatStatusResult Successful Response
 * @throws ApiError
 */
export const catRunStatuses = (
  data: CatRunStatusesData
): CancelablePromise<CatRunStatusesResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/cat/status",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Resume Cat Pipeline
 * Resume ``batch_id`` (the run the user picked) from where it stalled.
 * See rms_pipeline.md ("In-place resume"). RMS_ELT / RMS_22 route
 * through the per-peril resume; ICM_YLT routes through the per-chunk
 * resume — same in-place semantics either way. SpatialKat is the exception:
 * it has no in-place resume, so it reprices the failed batch's stored SELs
 * into a **new** batch, and the returned ``batch_id`` is that new one. A
 * SpatialKat run whose analysis stage failed has nothing stored to reprice
 * and is refused with a message saying to run it again.
 * ``mode`` applies to ICM_YLT only:
 * ``"resume"`` keeps each failed chunk's ICM status URL (continue
 * polling); ``"restart"`` drops it so re-dispatched chunks submit fresh
 * ICM ratings — for runs stuck on a status URL that never resolves.
 * @param data The data for the request.
 * @param data.reportId
 * @param data.type
 * @param data.batchId
 * @param data.mode
 * @returns CatResumeResult Successful Response
 * @throws ApiError
 */
export const resumeCatPipeline = (
  data: ResumeCatPipelineData
): CancelablePromise<ResumeCatPipelineResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/cat/{report_id}/resume",
    path: {
      report_id: data.reportId,
    },
    query: {
      type: data.type,
      batch_id: data.batchId,
      mode: data.mode,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Rerun Cat Financial
 * Re-run only the financial stage for ``batch_id`` (the run the user
 * picked), reusing its cached model artifacts. See rms_pipeline.md
 * ("New-batch financial re-run"). RMS_ELT / RMS_22 reuse per-peril ELT
 * artifacts; ICM_YLT reuses per-chunk YLT artifacts; SpatialKat reuses its
 * per-run SELs — each creates a new batch with one task that reads from the
 * source batch.
 *
 * ``activate`` False runs a shadow re-run: results land as inactive history
 * (inspectable by batch_id) without replacing the report's active results.
 * @param data The data for the request.
 * @param data.reportId
 * @param data.type
 * @param data.batchId
 * @param data.activate
 * @returns CatRerunFinancialResult Successful Response
 * @throws ApiError
 */
export const rerunCatFinancial = (
  data: RerunCatFinancialData
): CancelablePromise<RerunCatFinancialResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/cat/{report_id}/rerun-financial",
    path: {
      report_id: data.reportId,
    },
    query: {
      type: data.type,
      batch_id: data.batchId,
      activate: data.activate,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Activate Cat Batch
 * Promote ``batch_id`` (the run the user picked) to this vendor's live
 * results for the report: its stored results become the ones every CAT read
 * resolves to, and the rest of the history goes inactive. Nothing is
 * re-modeled, so a shadow run can be adopted — or an earlier run rolled back
 * to — without re-running the vendor.
 *
 * The active batch is also what staleness is measured against and what an
 * automatic reprice re-finances from (``cat_run_reconcile``), so this
 * redirects those onto the adopted run too.
 * @param data The data for the request.
 * @param data.reportId
 * @param data.type
 * @param data.batchId
 * @returns CatActivateResult Successful Response
 * @throws ApiError
 */
export const activateCatBatch = (
  data: ActivateCatBatchData
): CancelablePromise<ActivateCatBatchResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/cat/{report_id}/activate",
    path: {
      report_id: data.reportId,
    },
    query: {
      type: data.type,
      batch_id: data.batchId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Vendor Enrichment
 * Per vendor, the vendor data its live run modeled with and which sources
 * it holds completed runs under, for the Layers tab.
 * @param data The data for the request.
 * @param data.reportId
 * @returns VendorEnrichmentState Successful Response
 * @throws ApiError
 */
export const getVendorEnrichment = (
  data: GetVendorEnrichmentData
): CancelablePromise<GetVendorEnrichmentResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/cat/{report_id}/vendor_enrichment",
    path: {
      report_id: data.reportId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Set Vendor Enrichment
 * Switch each selected vendor onto the run it already holds under the
 * chosen source: it becomes the vendor's live results. Nothing is re-modeled.
 * 409, with nothing switched, while a selected vendor is modeling or lacks a
 * run under its source.
 * @param data The data for the request.
 * @param data.reportId
 * @param data.requestBody
 * @returns VendorEnrichmentState Successful Response
 * @throws ApiError
 */
export const setVendorEnrichment = (
  data: SetVendorEnrichmentData
): CancelablePromise<SetVendorEnrichmentResponse> => {
  return __request(OpenAPI, {
    method: "PUT",
    url: "/cat/{report_id}/vendor_enrichment",
    path: {
      report_id: data.reportId,
    },
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Deductible Summary
 * @param data The data for the request.
 * @param data.requestBody
 * @returns DeductibleSummaryResponse Successful Response
 * @throws ApiError
 */
export const getDeductibleSummary = (
  data: GetDeductibleSummaryData
): CancelablePromise<GetDeductibleSummaryResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/deductible_summary",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Run Fix Sov
 * @param data The data for the request.
 * @param data.requestBody
 * @returns RunFixSovResponse Successful Response
 * @throws ApiError
 */
export const asgardRunFixSov = (
  data: AsgardRunFixSovData
): CancelablePromise<AsgardRunFixSovResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/run_fix_sov",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Set Function Instructions
 * @param data The data for the request.
 * @param data.requestBody
 * @returns SetFunctionInstructionsResponse Successful Response
 * @throws ApiError
 */
export const asgardSetFunctionInstructions = (
  data: AsgardSetFunctionInstructionsData
): CancelablePromise<AsgardSetFunctionInstructionsResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/set_function_instructions",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard List Clearance Metadata
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ListClearanceMetadataResponse Successful Response
 * @throws ApiError
 */
export const asgardListClearanceMetadata = (
  data: AsgardListClearanceMetadataData
): CancelablePromise<AsgardListClearanceMetadataResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/list_clearance_metadata",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Ingest Email
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const asgardIngestEmail = (
  data: AsgardIngestEmailData
): CancelablePromise<AsgardIngestEmailResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/ingest_email",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Initiate Cape Request
 * @param data The data for the request.
 * @param data.requestBody
 * @returns CapeInitiateResponse Successful Response
 * @throws ApiError
 */
export const initiateCapeRequest = (
  data: InitiateCapeRequestData
): CancelablePromise<InitiateCapeRequestResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/cape_analytics/initiate",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Cape Request Status
 * @param data The data for the request.
 * @param data.requestId
 * @returns IntegrationStatusResult Successful Response
 * @throws ApiError
 */
export const capeRequestStatus = (
  data: CapeRequestStatusData
): CancelablePromise<CapeRequestStatusResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/cape_analytics/status/{request_id}",
    path: {
      request_id: data.requestId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Cape Job History
 * @param data The data for the request.
 * @param data.reportId
 * @returns CapeJobHistoryResponse Successful Response
 * @throws ApiError
 */
export const getCapeJobHistory = (
  data: GetCapeJobHistoryData
): CancelablePromise<GetCapeJobHistoryResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/cape_analytics/job_history/{report_id}",
    path: {
      report_id: data.reportId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Enqueue Replacement Cost
 * Score the report's enabled locations with Sindri, in "full" mode, and
 * make the results the report's live replacement cost. Rejects with 400 a
 * report the task could not build a request for, such as one with no
 * enabled locations.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns SindriEnqueueResponse Successful Response
 * @throws ApiError
 */
export const enqueueReplacementCost = (
  data: EnqueueReplacementCostData
): CancelablePromise<EnqueueReplacementCostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/sindri/replacement_cost",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Integration Data
 * @param data The data for the request.
 * @param data.requestBody
 * @returns IntegrationDataResponse Successful Response
 * @throws ApiError
 */
export const getIntegrationData = (
  data: GetIntegrationDataData
): CancelablePromise<GetIntegrationDataResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/integration_data",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Financial Model Audit
 * Per-run financial-model audit for one cat source (ground-up → deductible
 * → limit → gross, by peril/layer/limit-zone). ``None`` when the source has no
 * standalone audit (the blend), no run, a run predating the audit, or an
 * unreadable blob. The Layers tab treats them all as "no audit to show".
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const getFinancialModelAudit = (
  data: GetFinancialModelAuditData
): CancelablePromise<GetFinancialModelAuditResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/financial_model_audit",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Bulk Enrich Submissions
 * Enqueue third-party enrichment for many reports in one admin action.
 *
 * Creates one low-priority batch per (report, source), so a large sweep yields
 * to interactive work. Batches are enqueued as the calling admin, so the runs
 * show under their name in the job queue. Reports that are missing or
 * have no addresses are skipped and reported back rather than failing the whole
 * request. The auto-enrichment size caps don't apply here (this is an explicit
 * admin action); re-running is safe since vendor fetches are cached and new
 * tasks supersede prior in-flight ones.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns BulkEnrichmentResponse Successful Response
 * @throws ApiError
 */
export const bulkEnrichSubmissions = (
  data: BulkEnrichSubmissionsData
): CancelablePromise<BulkEnrichSubmissionsResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/enrichment/bulk",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Limit Summary
 * @param data The data for the request.
 * @param data.requestBody
 * @returns LimitSummaryResponse Successful Response
 * @throws ApiError
 */
export const getLimitSummary = (
  data: GetLimitSummaryData
): CancelablePromise<GetLimitSummaryResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/limit_summary",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Layer Gate Exposure
 * @param data The data for the request.
 * @param data.requestBody
 * @returns GateExposureResponse Successful Response
 * @throws ApiError
 */
export const getLayerGateExposure = (
  data: GetLayerGateExposureData
): CancelablePromise<GetLayerGateExposureResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/layer_gate_exposure",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Gate Tracking Base
 * Per-gate accumulation bars: bound + quoted portfolio fill (from precomputed
 * contributions) plus this layer's live exposure, against each gate's tracking
 * base. The current report is excluded from the portfolio sums so a bound/quoted
 * deal isn't counted against itself.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns GateTrackingBaseResponse Successful Response
 * @throws ApiError
 */
export const getGateTrackingBase = (
  data: GetGateTrackingBaseData
): CancelablePromise<GetGateTrackingBaseResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/gate_tracking_base",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Portfolio Gate Accumulation
 * Book-wide gate accumulation: bound + quoted fill against every gate's
 * tracking base, with no current-layer segment. Every gate is returned (even
 * empty ones) so the underwriter sees headroom across the whole portfolio.
 * @returns PortfolioGateAccumulationResponse Successful Response
 * @throws ApiError
 */
export const getPortfolioGateAccumulation =
  (): CancelablePromise<GetPortfolioGateAccumulationResponse> => {
    return __request(OpenAPI, {
      method: "POST",
      url: "/portfolio_gate_accumulation",
    });
  };

/**
 * Get Aal Premium Gate Portfolio
 * Book-wide per-gate view: cumulative net AAL against each gate's annual
 * budget, plus the running loss ratio (bound, bound+quoted) against target.
 * current_aal / effect_on_bound are None — no deal is in scope.
 * @returns AalPremiumGateResponse Successful Response
 * @throws ApiError
 */
export const getAalPremiumGatePortfolio =
  (): CancelablePromise<GetAalPremiumGatePortfolioResponse> => {
    return __request(OpenAPI, {
      method: "POST",
      url: "/aal_premium_gate_portfolio",
    });
  };

/**
 * Get Aal Premium Gate Tracking
 * Per-gate view for one layer: the book (bound + quoted, excluding this exact
 * layer so the deal's other layers still count) plus the layer's own live
 * contribution as the 'this deal' overlay. Layer-scoped to match the geographic
 * gate view shown alongside it — premium, AAL, and loss ratio are for this layer.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns AalPremiumGateResponse Successful Response
 * @throws ApiError
 */
export const getAalPremiumGateTracking = (
  data: GetAalPremiumGateTrackingData
): CancelablePromise<GetAalPremiumGateTrackingResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/aal_premium_gate_tracking",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Standard Formatting
 * @param data The data for the request.
 * @param data.requestBody
 * @returns FormattedText Successful Response
 * @throws ApiError
 */
export const standardFormatting = (
  data: StandardFormattingData
): CancelablePromise<StandardFormattingResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/standard_formatting",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Initiate Nearmap Request
 * @param data The data for the request.
 * @param data.requestBody
 * @returns NearmapInitiateResponse Successful Response
 * @throws ApiError
 */
export const initiateNearmapRequest = (
  data: InitiateNearmapRequestData
): CancelablePromise<InitiateNearmapRequestResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/nearmap/initiate",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Nearmap Request Status
 * @param data The data for the request.
 * @param data.requestId
 * @returns IntegrationStatusResult Successful Response
 * @throws ApiError
 */
export const nearmapRequestStatus = (
  data: NearmapRequestStatusData
): CancelablePromise<NearmapRequestStatusResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/nearmap/status/{request_id}",
    path: {
      request_id: data.requestId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Nearmap Job History
 * @param data The data for the request.
 * @param data.reportId
 * @returns NearmapJobHistoryResponse Successful Response
 * @throws ApiError
 */
export const getNearmapJobHistory = (
  data: GetNearmapJobHistoryData
): CancelablePromise<GetNearmapJobHistoryResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/nearmap/job_history/{report_id}",
    path: {
      report_id: data.reportId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Periodic Hourly
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const periodicHourly = (): CancelablePromise<PeriodicHourlyResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/periodic/hourly",
  });
};

/**
 * Periodic Nightly
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const periodicNightly =
  (): CancelablePromise<PeriodicNightlyResponse> => {
    return __request(OpenAPI, {
      method: "POST",
      url: "/periodic/nightly",
    });
  };

/**
 * Periodic Every 5M
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const periodicEvery5M =
  (): CancelablePromise<PeriodicEvery5MResponse> => {
    return __request(OpenAPI, {
      method: "POST",
      url: "/periodic/every_5m",
    });
  };

/**
 * Calculate Premium
 * Compute suggested premiums for all layers in a report.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns CalculatedPremiumResponse Successful Response
 * @throws ApiError
 */
export const calculatePremium = (
  data: CalculatePremiumData
): CancelablePromise<CalculatePremiumResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/premium/calculated",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Resolved Premiums
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ResolvedPremiumsResponse Successful Response
 * @throws ApiError
 */
export const getResolvedPremiums = (
  data: GetResolvedPremiumsData
): CancelablePromise<GetResolvedPremiumsResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/premium/resolved",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Reconcile Policyfly
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const reconcilePolicyfly =
  (): CancelablePromise<ReconcilePolicyflyResponse> => {
    return __request(OpenAPI, {
      method: "POST",
      url: "/asgard/reconcile_policyfly",
    });
  };

/**
 * Download Rater Workbook
 * @param data The data for the request.
 * @param data.reportId
 * @param data.batchId
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const downloadRaterWorkbook = (
  data: DownloadRaterWorkbookData
): CancelablePromise<DownloadRaterWorkbookResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/rater/download/{report_id}/{batch_id}",
    path: {
      report_id: data.reportId,
      batch_id: data.batchId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Rate Components
 * @param data The data for the request.
 * @param data.reportId
 * @param data.batchId
 * @returns RateComponentsResponse Successful Response
 * @throws ApiError
 */
export const getRateComponents = (
  data: GetRateComponentsData
): CancelablePromise<GetRateComponentsResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/rater/rate_components/{report_id}/{batch_id}",
    path: {
      report_id: data.reportId,
      batch_id: data.batchId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Eqbd Rater Results
 * @param data The data for the request.
 * @param data.reportId
 * @param data.batchId
 * @returns EqbdRaterResultsResponse Successful Response
 * @throws ApiError
 */
export const getEqbdRaterResults = (
  data: GetEqbdRaterResultsData
): CancelablePromise<GetEqbdRaterResultsResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/eqbd_rater/results/{report_id}/{batch_id}",
    path: {
      report_id: data.reportId,
      batch_id: data.batchId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Book Summary
 * @param data The data for the request.
 * @param data.lob
 * @returns BookSummaryResponse Successful Response
 * @throws ApiError
 */
export const getBookSummary = (
  data: GetBookSummaryData
): CancelablePromise<GetBookSummaryResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/asgard/reinsurer_view/book_summary",
    query: {
      lob: data.lob,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Submission Analytics
 * @returns SubmissionAnalyticsResponse Successful Response
 * @throws ApiError
 */
export const getSubmissionAnalytics =
  (): CancelablePromise<GetSubmissionAnalyticsResponse> => {
    return __request(OpenAPI, {
      method: "GET",
      url: "/asgard/submission_analytics",
    });
  };

/**
 * Get Exposure Map Summary
 * Everything one scope needs in a single read: places, gates, policies.
 *
 * One response rather than several so the figures on screen cannot disagree
 * with each other. ``status_breakdown`` ignores the request's status filter,
 * so the counts behind the filter chips hold still as they are toggled.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ExposureMapSummary Successful Response
 * @throws ApiError
 */
export const getExposureMapSummary = (
  data: GetExposureMapSummaryData
): CancelablePromise<GetExposureMapSummaryResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/exposure_map/summary",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Exposure Map Locations
 * Individual locations for the requested scope, highest TIV first.
 *
 * Capped at LOCATION_LIMIT; ``truncated`` says whether rows were left behind,
 * so the caller can tell a partial view from a complete one.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ExposureMapLocations Successful Response
 * @throws ApiError
 */
export const getExposureMapLocations = (
  data: GetExposureMapLocationsData
): CancelablePromise<GetExposureMapLocationsResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/exposure_map/locations",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Area Exposure
 * Accumulate over a drawn shape rather than an administrative boundary.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns AreaExposure Successful Response
 * @throws ApiError
 */
export const getAreaExposure = (
  data: GetAreaExposureData
): CancelablePromise<GetAreaExposureResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/exposure_map/area",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Policy Footprint
 * One policy's spread across states and counties.
 *
 * Served from the memoized cube, so this costs a fold over ~8k cells and no
 * query at all.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns PolicyFootprint Successful Response
 * @throws ApiError
 */
export const getPolicyFootprint = (
  data: GetPolicyFootprintData
): CancelablePromise<GetPolicyFootprintResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/exposure_map/policy_footprint",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Get Active Storms
 * Active named storms with their forecast tracks, Atlantic and Pacific.
 *
 * An empty list is the ordinary out-of-season answer, not a failure.
 * @returns ActiveStorms Successful Response
 * @throws ApiError
 */
export const getActiveStorms =
  (): CancelablePromise<GetActiveStormsResponse> => {
    return __request(OpenAPI, {
      method: "GET",
      url: "/asgard/storms/active",
    });
  };

/**
 * Get Past Storms
 * Storms the NHC has finished advising on, with their observed tracks.
 *
 * The current season, every basin, and only those that came within reach of
 * somewhere we write — around a third of a season qualifies. Most recent
 * first, since that is the one a caller usually wants. Out of season this is
 * what the map has to draw, and in season it is how a live storm's damage
 * gets a precedent.
 * @returns PastStorms Successful Response
 * @throws ApiError
 */
export const getPastStorms = (): CancelablePromise<GetPastStormsResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/asgard/storms/past",
  });
};

/**
 * Get Location Classifications
 * @param data The data for the request.
 * @param data.requestBody
 * @returns LocationClassificationsResponse Successful Response
 * @throws ApiError
 */
export const getLocationClassifications = (
  data: GetLocationClassificationsData
): CancelablePromise<GetLocationClassificationsResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/location_classifications",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Create Policy Applications
 * @param data The data for the request.
 * @param data.requestBody
 * @returns PolicyApplicationsResponse Successful Response
 * @throws ApiError
 */
export const asgardCreatePolicyApplications = (
  data: AsgardCreatePolicyApplicationsData
): CancelablePromise<AsgardCreatePolicyApplicationsResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/policy/create_applications",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard List Policy Applications
 * @param data The data for the request.
 * @param data.requestBody
 * @returns PolicyApplicationsResponse Successful Response
 * @throws ApiError
 */
export const asgardListPolicyApplications = (
  data: AsgardListPolicyApplicationsData
): CancelablePromise<AsgardListPolicyApplicationsResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/policy/list_applications",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Policy Application Fields
 * @param data The data for the request.
 * @param data.requestBody
 * @returns PolicyApplicationFieldsResponse Successful Response
 * @throws ApiError
 */
export const asgardPolicyApplicationFields = (
  data: AsgardPolicyApplicationFieldsData
): CancelablePromise<AsgardPolicyApplicationFieldsResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/policy/application_fields",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Update Policy Overlay
 * @param data The data for the request.
 * @param data.requestBody
 * @returns PolicyApplicationFieldsResponse Successful Response
 * @throws ApiError
 */
export const asgardUpdatePolicyOverlay = (
  data: AsgardUpdatePolicyOverlayData
): CancelablePromise<AsgardUpdatePolicyOverlayResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/policy/update_overlay",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Update Policy Application
 * Set the status. The overlay and form selections are saved through their
 * own endpoints.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns PolicyApplicationView Successful Response
 * @throws ApiError
 */
export const asgardUpdatePolicyApplication = (
  data: AsgardUpdatePolicyApplicationData
): CancelablePromise<AsgardUpdatePolicyApplicationResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/policy/update_application",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Policy Application Forms
 * @param data The data for the request.
 * @param data.requestBody
 * @returns PolicyApplicationFormsResponse Successful Response
 * @throws ApiError
 */
export const asgardPolicyApplicationForms = (
  data: AsgardPolicyApplicationFormsData
): CancelablePromise<AsgardPolicyApplicationFormsResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/policy/application_forms",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Update Application Form
 * @param data The data for the request.
 * @param data.requestBody
 * @returns PolicyApplicationFormsResponse Successful Response
 * @throws ApiError
 */
export const asgardUpdateApplicationForm = (
  data: AsgardUpdateApplicationFormData
): CancelablePromise<AsgardUpdateApplicationFormResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/policy/update_application_form",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Application Quote Template
 * The application's effective quote template: its saved customization, or
 * the repo's base template, with ``QuoteTemplateMeta`` in the response
 * metadata header.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const asgardApplicationQuoteTemplate = (
  data: AsgardApplicationQuoteTemplateData
): CancelablePromise<AsgardApplicationQuoteTemplateResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/policy/application_quote_template",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Save Application Quote Template
 * Persist an edited quote template for one application. The template is
 * trial-rendered against the application's real data first, so a broken
 * jinja tag is rejected here instead of failing every later generation.
 * @param data The data for the request.
 * @param data.formData
 * @returns SaveQuoteTemplateResponse Successful Response
 * @throws ApiError
 */
export const asgardSaveApplicationQuoteTemplate = (
  data: AsgardSaveApplicationQuoteTemplateData
): CancelablePromise<AsgardSaveApplicationQuoteTemplateResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/policy/save_application_quote_template",
    formData: data.formData,
    mediaType: "multipart/form-data",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Reset Application Quote Template
 * Drop the application's saved template so it uses the base again.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns SaveQuoteTemplateResponse Successful Response
 * @throws ApiError
 */
export const asgardResetApplicationQuoteTemplate = (
  data: AsgardResetApplicationQuoteTemplateData
): CancelablePromise<AsgardResetApplicationQuoteTemplateResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/policy/reset_application_quote_template",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Application Quote Unknowns
 * The ``[[ UNKNOWN: … ]]`` marker names a quote render would leave in the
 * letter, so the client can ask for confirmation before one is attached to
 * the report. Renders the docx (no PDF conversion) and persists nothing.
 * @param data The data for the request.
 * @param data.formData
 * @returns QuoteUnknownsResponse Successful Response
 * @throws ApiError
 */
export const asgardApplicationQuoteUnknowns = (
  data: AsgardApplicationQuoteUnknownsData
): CancelablePromise<AsgardApplicationQuoteUnknownsResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/policy/application_quote_unknowns",
    formData: data.formData,
    mediaType: "multipart/form-data",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Generate Application Quote
 * Render the quote letter for one application as docx or pdf.
 *
 * The editor ships its current export as ``template``; without one, the
 * saved template (or the base) is used. ``persist_template`` stores a
 * successfully-rendered upload as the application's saved template — false
 * for a live preview, so previewing never silently saves layout edits.
 * ``full_package`` wraps the PDF in the broker-facing quote package (state
 * notices, OFAC, TRIA disclosure, fraud notice, SL license form); a preview
 * render is the letter alone. ``save_to_report`` also stores the rendered
 * document as a report attachment tagged with this application's id. PDF
 * falls back to docx when the backend has no LibreOffice binary.
 * @param data The data for the request.
 * @param data.formData
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const asgardGenerateApplicationQuote = (
  data: AsgardGenerateApplicationQuoteData
): CancelablePromise<AsgardGenerateApplicationQuoteResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/policy/generate_application_quote",
    formData: data.formData,
    mediaType: "multipart/form-data",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard List Endorsements
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ListEndorsementsResponse Successful Response
 * @throws ApiError
 */
export const asgardListEndorsements = (
  data: AsgardListEndorsementsData
): CancelablePromise<AsgardListEndorsementsResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/endorsements/list",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Create Endorsement
 * @param data The data for the request.
 * @param data.formData
 * @returns EndorsementView Successful Response
 * @throws ApiError
 */
export const asgardCreateEndorsement = (
  data: AsgardCreateEndorsementData
): CancelablePromise<AsgardCreateEndorsementResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/endorsements/create",
    formData: data.formData,
    mediaType: "multipart/form-data",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Upload Endorsement Documents
 * @param data The data for the request.
 * @param data.formData
 * @returns EndorsementView Successful Response
 * @throws ApiError
 */
export const asgardUploadEndorsementDocuments = (
  data: AsgardUploadEndorsementDocumentsData
): CancelablePromise<AsgardUploadEndorsementDocumentsResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/endorsements/upload_documents",
    formData: data.formData,
    mediaType: "multipart/form-data",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Suggest Endorsement Premium
 * @param data The data for the request.
 * @param data.requestBody
 * @returns EndorsementPremiumChange Successful Response
 * @throws ApiError
 */
export const asgardSuggestEndorsementPremium = (
  data: AsgardSuggestEndorsementPremiumData
): CancelablePromise<AsgardSuggestEndorsementPremiumResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/endorsements/suggest_premium",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Estimate Endorsement Premium
 * An up-front account-rate estimate for an endorsement being drafted,
 * before it exists: rate off the report's current TIV toward the entered
 * target. The post-generation suggestion (achieved TIV) supersedes this.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns EndorsementPremiumChange Successful Response
 * @throws ApiError
 */
export const asgardEstimateEndorsementPremium = (
  data: AsgardEstimateEndorsementPremiumData
): CancelablePromise<AsgardEstimateEndorsementPremiumResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/endorsements/estimate_premium",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Update Endorsement Premium
 * @param data The data for the request.
 * @param data.requestBody
 * @returns EndorsementView Successful Response
 * @throws ApiError
 */
export const asgardUpdateEndorsementPremium = (
  data: AsgardUpdateEndorsementPremiumData
): CancelablePromise<AsgardUpdateEndorsementPremiumResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/endorsements/update_premium",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Update Endorsement Status
 * @param data The data for the request.
 * @param data.requestBody
 * @returns EndorsementView Successful Response
 * @throws ApiError
 */
export const asgardUpdateEndorsementStatus = (
  data: AsgardUpdateEndorsementStatusData
): CancelablePromise<AsgardUpdateEndorsementStatusResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/endorsements/update_status",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Delete Endorsement
 * @param data The data for the request.
 * @param data.requestBody
 * @returns DeleteEndorsementResponse Successful Response
 * @throws ApiError
 */
export const asgardDeleteEndorsement = (
  data: AsgardDeleteEndorsementData
): CancelablePromise<AsgardDeleteEndorsementResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/endorsements/delete",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Endorsement Sov Diff
 * The endorsed schedule diffed against its baseline: the latest verified
 * endorsed schedule created before this endorsement, else the report's own
 * (bound) schedule.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns EndorsementSovDiffResponse Successful Response
 * @throws ApiError
 */
export const asgardEndorsementSovDiff = (
  data: AsgardEndorsementSovDiffData
): CancelablePromise<AsgardEndorsementSovDiffResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/endorsements/sov_diff",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Regenerate Endorsement
 * Run generation again for an endorsement awaiting review — the recovery
 * path when a run failed (``generation_error``), or when a reviewer wants a
 * fresh attempt. Also rescues a row stuck in ``generating`` whose job died
 * without running the handler (e.g. dropped by the queue), as long as no run
 * is actually in flight. A new schedule replaces the stored one on submit.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns EndorsementView Successful Response
 * @throws ApiError
 */
export const asgardRegenerateEndorsement = (
  data: AsgardRegenerateEndorsementData
): CancelablePromise<AsgardRegenerateEndorsementResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/endorsements/regenerate",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Healthcheck
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const healthcheck = (): CancelablePromise<HealthcheckResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/healthcheck",
  });
};

/**
 * Login
 * @param data The data for the request.
 * @param data.formData
 * @returns LoginResponse Successful Response
 * @throws ApiError
 */
export const login = (data: LoginData): CancelablePromise<LoginResponse2> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/login",
    formData: data.formData,
    mediaType: "application/x-www-form-urlencoded",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * List Users
 * @returns ListUserResponse Successful Response
 * @throws ApiError
 */
export const listUsers = (): CancelablePromise<ListUsersResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/list_users",
  });
};

/**
 * Log Event
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const logEvent = (
  data: LogEventData
): CancelablePromise<LogEventResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/log_event",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard List Reports Post
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ListReportsResponse Successful Response
 * @throws ApiError
 */
export const asgardListReportsPost = (
  data: AsgardListReportsPostData
): CancelablePromise<AsgardListReportsPostResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/list_reports",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard List Report
 * With include_loss_run=false, report_json.loss_run comes back empty even
 * when the report has loss runs.
 * @param data The data for the request.
 * @param data.reportId
 * @param data.includeAddresses
 * @param data.includeLossRun
 * @returns ReportResponse Successful Response
 * @throws ApiError
 */
export const asgardListReport = (
  data: AsgardListReportData
): CancelablePromise<AsgardListReportResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/asgard/list_report/{report_id}",
    path: {
      report_id: data.reportId,
    },
    query: {
      include_addresses: data.includeAddresses,
      include_loss_run: data.includeLossRun,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Freshness
 * @param data The data for the request.
 * @param data.requestBody
 * @returns FreshnessResponse Successful Response
 * @throws ApiError
 */
export const asgardFreshness = (
  data: AsgardFreshnessData
): CancelablePromise<AsgardFreshnessResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/freshness",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Google Group Stats
 * @param data The data for the request.
 * @param data.requestBody
 * @returns GoogleGroupStats Successful Response
 * @throws ApiError
 */
export const asgardGoogleGroupStats = (
  data: AsgardGoogleGroupStatsData
): CancelablePromise<AsgardGoogleGroupStatsResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/google_group_stats",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Email Threads
 * Fetch full conversation data for all email threads on a report.
 * @param data The data for the request.
 * @param data.reportId
 * @returns EmailThreadsResponse Successful Response
 * @throws ApiError
 */
export const asgardEmailThreads = (
  data: AsgardEmailThreadsData
): CancelablePromise<AsgardEmailThreadsResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/asgard/email_threads/{report_id}",
    path: {
      report_id: data.reportId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Delete Email Thread
 * Remove an email thread from a report, retire its files, and reprocess
 * any components that attachments extracted from the thread fed.
 * @param data The data for the request.
 * @param data.reportId
 * @param data.requestBody
 * @returns DeleteEmailThreadResponse Successful Response
 * @throws ApiError
 */
export const asgardDeleteEmailThread = (
  data: AsgardDeleteEmailThreadData
): CancelablePromise<AsgardDeleteEmailThreadResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/delete_email_thread/{report_id}",
    path: {
      report_id: data.reportId,
    },
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Download Thread Attachment
 * Download an attachment from an email thread message via Microsoft Graph.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const asgardDownloadThreadAttachment = (
  data: AsgardDownloadThreadAttachmentData
): CancelablePromise<AsgardDownloadThreadAttachmentResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/download_thread_attachment",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Generate Underwriting Pdf
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const asgardGenerateUnderwritingPdf = (
  data: AsgardGenerateUnderwritingPdfData
): CancelablePromise<AsgardGenerateUnderwritingPdfResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/generate_underwriting_pdf",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Quote Indication Preflight
 * Compute the fields shown in the quote indication modal (and used in the
 * drafted email) from server-side data. Keeps the frontend and the drafted
 * email from drifting apart.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns QuoteIndicationPreflight Successful Response
 * @throws ApiError
 */
export const asgardQuoteIndicationPreflight = (
  data: AsgardQuoteIndicationPreflightData
): CancelablePromise<AsgardQuoteIndicationPreflightResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/quote_indication_preflight",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Generate Quote Indication Draft
 * Create an Outlook draft with the quote indication
 * @param data The data for the request.
 * @param data.requestBody
 * @returns DraftResponse Successful Response
 * @throws ApiError
 */
export const asgardGenerateQuoteIndicationDraft = (
  data: AsgardGenerateQuoteIndicationDraftData
): CancelablePromise<AsgardGenerateQuoteIndicationDraftResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/generate_quote_indication_draft",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Quote Indication Html
 * Render the quote indication email body and tracking BCC for the
 * copy-to-clipboard flow. Mirrors the Outlook draft body exactly.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns QuoteIndicationHtmlResponse Successful Response
 * @throws ApiError
 */
export const asgardQuoteIndicationHtml = (
  data: AsgardQuoteIndicationHtmlData
): CancelablePromise<AsgardQuoteIndicationHtmlResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/quote_indication_html",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Generate Referral Draft
 * Create an Outlook draft with the referral write-up
 * @param data The data for the request.
 * @param data.requestBody
 * @returns DraftResponse Successful Response
 * @throws ApiError
 */
export const asgardGenerateReferralDraft = (
  data: AsgardGenerateReferralDraftData
): CancelablePromise<AsgardGenerateReferralDraftResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/generate_referral_draft",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Download Loss Run
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const asgardDownloadLossRun = (
  data: AsgardDownloadLossRunData
): CancelablePromise<AsgardDownloadLossRunResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/download_loss_run",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Update Report
 * @param data The data for the request.
 * @param data.requestBody
 * @returns UpdateReportResponse Successful Response
 * @throws ApiError
 */
export const asgardUpdateReport = (
  data: AsgardUpdateReportData
): CancelablePromise<AsgardUpdateReportResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/update_report",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Add Manual Address
 * @param data The data for the request.
 * @param data.requestBody
 * @returns AddManualAddressResponse Successful Response
 * @throws ApiError
 */
export const asgardAddManualAddress = (
  data: AsgardAddManualAddressData
): CancelablePromise<AsgardAddManualAddressResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/add_manual_address",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Batch Comments
 * @param data The data for the request.
 * @param data.requestBody
 * @returns BatchCommentsResponse Successful Response
 * @throws ApiError
 */
export const asgardBatchComments = (
  data: AsgardBatchCommentsData
): CancelablePromise<AsgardBatchCommentsResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/comments",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Add Comment
 * @param data The data for the request.
 * @param data.requestBody
 * @returns AddCommentResponse Successful Response
 * @throws ApiError
 */
export const asgardAddComment = (
  data: AsgardAddCommentData
): CancelablePromise<AsgardAddCommentResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/add_comment",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Delete Comment
 * @param data The data for the request.
 * @param data.requestBody
 * @returns DeleteCommentResponse Successful Response
 * @throws ApiError
 */
export const asgardDeleteComment = (
  data: AsgardDeleteCommentData
): CancelablePromise<AsgardDeleteCommentResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/delete_comment",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Edit Comment
 * @param data The data for the request.
 * @param data.requestBody
 * @returns EditCommentResponse Successful Response
 * @throws ApiError
 */
export const asgardEditComment = (
  data: AsgardEditCommentData
): CancelablePromise<AsgardEditCommentResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/edit_comment",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Delete Report
 * @param data The data for the request.
 * @param data.requestBody
 * @returns DeleteReportResponse Successful Response
 * @throws ApiError
 */
export const asgardDeleteReport = (
  data: AsgardDeleteReportData
): CancelablePromise<AsgardDeleteReportResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/delete_report",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Update Address
 * @param data The data for the request.
 * @param data.requestBody
 * @returns UpdateAddressResponse Successful Response
 * @throws ApiError
 */
export const asgardUpdateAddress = (
  data: AsgardUpdateAddressData
): CancelablePromise<AsgardUpdateAddressResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/update_address",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard List Additional Files
 * @param data The data for the request.
 * @param data.reportId
 * @returns ListAdditionalFilesResponse Successful Response
 * @throws ApiError
 */
export const asgardListAdditionalFiles = (
  data: AsgardListAdditionalFilesData
): CancelablePromise<AsgardListAdditionalFilesResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/list_additional_files/{report_id}",
    path: {
      report_id: data.reportId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Delete Additional Files
 * @param data The data for the request.
 * @param data.reportId
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const asgardDeleteAdditionalFiles = (
  data: AsgardDeleteAdditionalFilesData
): CancelablePromise<AsgardDeleteAdditionalFilesResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/delete_additional_files/{report_id}",
    path: {
      report_id: data.reportId,
    },
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Delete Attachment
 * Remove a user-uploaded attachment from a report.
 *
 * Moves the attachment's GCS blob into a ``deleted_attachments/`` folder and
 * drops its entry from ``attachment_info`` — the file no longer appears on the
 * report or gets reprocessed, but the blob is retained for recovery.
 * Attachments that came from the original email cannot be deleted.
 *
 * Removing an attachment drops its contributions from the components it fed
 * (a rerun scoped to just that file, which parses nothing), so the report
 * doesn't keep stale state from the deleted file.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns AttachmentInfo Successful Response
 * @throws ApiError
 */
export const asgardDeleteAttachment = (
  data: AsgardDeleteAttachmentData
): CancelablePromise<AsgardDeleteAttachmentResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/delete_attachment",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Test Python Function
 * @param data The data for the request.
 * @param data.reportId
 * @param data.requestBody
 * @returns TestPythonFunctionResponse Successful Response
 * @throws ApiError
 */
export const asgardTestPythonFunction = (
  data: AsgardTestPythonFunctionData
): CancelablePromise<AsgardTestPythonFunctionResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/test_python_function/{report_id}",
    path: {
      report_id: data.reportId,
    },
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Upload Additional File
 * @param data The data for the request.
 * @param data.reportId
 * @param data.formData
 * @param data.classificationForAllFiles
 * @param data.sourceForAllFiles
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const asgardUploadAdditionalFile = (
  data: AsgardUploadAdditionalFileData
): CancelablePromise<AsgardUploadAdditionalFileResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/upload_additional_files",
    query: {
      report_id: data.reportId,
      classification_for_all_files: data.classificationForAllFiles,
      source_for_all_files: data.sourceForAllFiles,
    },
    formData: data.formData,
    mediaType: "multipart/form-data",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Rerun Options
 * What the reprocess dialog can scope a rerun to: per component, the
 * attachments feeding it and whether the report already holds their data.
 * @param data The data for the request.
 * @param data.reportId
 * @returns RerunOptionsResponse Successful Response
 * @throws ApiError
 */
export const asgardRerunOptions = (
  data: AsgardRerunOptionsData
): CancelablePromise<AsgardRerunOptionsResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/asgard/rerun_options",
    query: {
      report_id: data.reportId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Upload Email Thread
 * @param data The data for the request.
 * @param data.reportId
 * @param data.formData
 * @returns UploadEmailThreadResponse Successful Response
 * @throws ApiError
 */
export const asgardUploadEmailThread = (
  data: AsgardUploadEmailThreadData
): CancelablePromise<AsgardUploadEmailThreadResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/upload_email_thread",
    query: {
      report_id: data.reportId,
    },
    formData: data.formData,
    mediaType: "multipart/form-data",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Classify Staged Attachment
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ClassifyStagedAttachmentResponse Successful Response
 * @throws ApiError
 */
export const asgardClassifyStagedAttachment = (
  data: AsgardClassifyStagedAttachmentData
): CancelablePromise<AsgardClassifyStagedAttachmentResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/classify_staged_attachment",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Extract Staged Attachments
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ExtractStagedAttachmentsResponse Successful Response
 * @throws ApiError
 */
export const asgardExtractStagedAttachments = (
  data: AsgardExtractStagedAttachmentsData
): CancelablePromise<AsgardExtractStagedAttachmentsResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/extract_staged_attachments",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Download Additional File
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const asgardDownloadAdditionalFile = (
  data: AsgardDownloadAdditionalFileData
): CancelablePromise<AsgardDownloadAdditionalFileResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/download_additional_file",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Generate Bulk Edit
 * @param data The data for the request.
 * @param data.requestBody
 * @returns BulkEditResponse Successful Response
 * @throws ApiError
 */
export const generateBulkEdit = (
  data: GenerateBulkEditData
): CancelablePromise<GenerateBulkEditResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/generate_bulk_edit",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Download Report File
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const downloadReportFile = (
  data: DownloadReportFileData
): CancelablePromise<DownloadReportFileResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/download_report_file",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Csp Report
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const cspReport = (): CancelablePromise<CspReportResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/csp-report",
  });
};

/**
 * Asgard List Saved Filters
 * @returns ListSavedFiltersResponse Successful Response
 * @throws ApiError
 */
export const asgardListSavedFilters =
  (): CancelablePromise<AsgardListSavedFiltersResponse> => {
    return __request(OpenAPI, {
      method: "POST",
      url: "/asgard/list_saved_filters",
    });
  };

/**
 * Asgard Delete Saved Filter
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ListSavedFiltersResponse Successful Response
 * @throws ApiError
 */
export const asgardDeleteSavedFilter = (
  data: AsgardDeleteSavedFilterData
): CancelablePromise<AsgardDeleteSavedFilterResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/delete_saved_filter",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Update Saved Filter
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ListSavedFiltersResponse Successful Response
 * @throws ApiError
 */
export const asgardUpdateSavedFilter = (
  data: AsgardUpdateSavedFilterData
): CancelablePromise<AsgardUpdateSavedFilterResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/update_saved_filter",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Add Saved Filter
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ListSavedFiltersResponse Successful Response
 * @throws ApiError
 */
export const asgardAddSavedFilter = (
  data: AsgardAddSavedFilterData
): CancelablePromise<AsgardAddSavedFilterResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/add_saved_filter",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Load Addresses For Map
 * @param data The data for the request.
 * @param data.requestBody
 * @returns LoadAddressesForMapResponse Successful Response
 * @throws ApiError
 */
export const asgardLoadAddressesForMap = (
  data: AsgardLoadAddressesForMapData
): CancelablePromise<AsgardLoadAddressesForMapResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/load_addresses_for_map",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Load Addresses
 * @param data The data for the request.
 * @param data.reportId
 * @param data.sovId
 * @returns AddressList Successful Response
 * @throws ApiError
 */
export const asgardLoadAddresses = (
  data: AsgardLoadAddressesData
): CancelablePromise<AsgardLoadAddressesResponse> => {
  return __request(OpenAPI, {
    method: "GET",
    url: "/asgard/load_addresses/{report_id}/{sov_id}",
    path: {
      report_id: data.reportId,
      sov_id: data.sovId,
    },
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Eml Preview
 * @param data The data for the request.
 * @param data.requestBody
 * @returns EmlPreviewResponse Successful Response
 * @throws ApiError
 */
export const asgardEmlPreview = (
  data: AsgardEmlPreviewData
): CancelablePromise<AsgardEmlPreviewResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/eml_preview",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Download Report History
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const asgardDownloadReportHistory = (
  data: AsgardDownloadReportHistoryData
): CancelablePromise<AsgardDownloadReportHistoryResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/download_report_history",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard List Updating Reports
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ListUpdatingReportsResponse Successful Response
 * @throws ApiError
 */
export const asgardListUpdatingReports = (
  data: AsgardListUpdatingReportsData
): CancelablePromise<AsgardListUpdatingReportsResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/list_updating_reports",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard List Report Jobs
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ListReportJobsResponse Successful Response
 * @throws ApiError
 */
export const asgardListReportJobs = (
  data: AsgardListReportJobsData
): CancelablePromise<AsgardListReportJobsResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/list_report_jobs",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Cancel Job
 * @param data The data for the request.
 * @param data.requestBody
 * @returns CancelJobResponse Successful Response
 * @throws ApiError
 */
export const asgardCancelJob = (
  data: AsgardCancelJobData
): CancelablePromise<AsgardCancelJobResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/cancel_job",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Set Batch Priority
 * Move a queued batch ahead of or behind other work in its topics.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns SetBatchPriorityResponse Successful Response
 * @throws ApiError
 */
export const asgardSetBatchPriority = (
  data: AsgardSetBatchPriorityData
): CancelablePromise<AsgardSetBatchPriorityResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/set_batch_priority",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard List Templates
 * @returns ListTemplatesResponse Successful Response
 * @throws ApiError
 */
export const asgardListTemplates =
  (): CancelablePromise<AsgardListTemplatesResponse> => {
    return __request(OpenAPI, {
      method: "POST",
      url: "/asgard/list_templates",
    });
  };

/**
 * Asgard Delete Template
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ListTemplatesResponse Successful Response
 * @throws ApiError
 */
export const asgardDeleteTemplate = (
  data: AsgardDeleteTemplateData
): CancelablePromise<AsgardDeleteTemplateResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/delete_template",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Update Template
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ListTemplatesResponse Successful Response
 * @throws ApiError
 */
export const asgardUpdateTemplate = (
  data: AsgardUpdateTemplateData
): CancelablePromise<AsgardUpdateTemplateResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/update_template",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Create Template
 * @param data The data for the request.
 * @param data.useCase
 * @param data.formData
 * @returns ListTemplatesResponse Successful Response
 * @throws ApiError
 */
export const asgardCreateTemplate = (
  data: AsgardCreateTemplateData
): CancelablePromise<AsgardCreateTemplateResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/create_template",
    query: {
      use_case: data.useCase,
    },
    formData: data.formData,
    mediaType: "multipart/form-data",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Download Template
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const asgardDownloadTemplate = (
  data: AsgardDownloadTemplateData
): CancelablePromise<AsgardDownloadTemplateResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/download_template",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Generate Policy Numbers
 * @param data The data for the request.
 * @param data.requestBody
 * @returns GeneratedPolicyNumbers Successful Response
 * @throws ApiError
 */
export const asgardGeneratePolicyNumbers = (
  data: AsgardGeneratePolicyNumbersData
): CancelablePromise<AsgardGeneratePolicyNumbersResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/generate_policy_numbers",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Generate Policy Fly Application
 * @param data The data for the request.
 * @param data.requestBody
 * @returns GeneratePolicyFlyApplicationResponse Successful Response
 * @throws ApiError
 */
export const asgardGeneratePolicyFlyApplication = (
  data: AsgardGeneratePolicyFlyApplicationData
): CancelablePromise<AsgardGeneratePolicyFlyApplicationResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/generate_policy_fly_application",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Update Policy Fly Application
 * Overwrite an existing PolicyFly application with the report's current data.
 *
 * PolicyFly pulls the application back to Draft and re-submits it with the
 * same mappings as creation; work done inside PolicyFly at the quote stage or
 * later is lost. The frontend confirms this with the user before calling.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns UpdatePolicyFlyApplicationResponse Successful Response
 * @throws ApiError
 */
export const asgardUpdatePolicyFlyApplication = (
  data: AsgardUpdatePolicyFlyApplicationData
): CancelablePromise<AsgardUpdatePolicyFlyApplicationResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/update_policy_fly_application",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Link Policy Fly Application
 * Associate a report with a PolicyFly application created outside of Asgard.
 *
 * This only records the link (layer, suffix, url) on the report. It does not
 * call PolicyFly. request_id is left unset, so the application cannot be
 * updated in place (its ULID request id is only returned at creation time via
 * our integration). Admin only.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns LinkPolicyFlyApplicationResponse Successful Response
 * @throws ApiError
 */
export const asgardLinkPolicyFlyApplication = (
  data: AsgardLinkPolicyFlyApplicationData
): CancelablePromise<AsgardLinkPolicyFlyApplicationResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/link_policy_fly_application",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Unlink Policy Fly Application
 * Remove the association between a report and a PolicyFly application.
 *
 * Only drops the link on our side; the application in PolicyFly is untouched.
 * The freed suffix becomes available for reuse. Admin only.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns UnlinkPolicyFlyApplicationResponse Successful Response
 * @throws ApiError
 */
export const asgardUnlinkPolicyFlyApplication = (
  data: AsgardUnlinkPolicyFlyApplicationData
): CancelablePromise<AsgardUnlinkPolicyFlyApplicationResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/unlink_policy_fly_application",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Clearance Email Recipients
 * Return the list of recipients that would receive a clearance email.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ClearanceEmailRecipientsResponse Successful Response
 * @throws ApiError
 */
export const asgardClearanceEmailRecipients = (
  data: AsgardClearanceEmailRecipientsData
): CancelablePromise<AsgardClearanceEmailRecipientsResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/clearance_email_recipients",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};

/**
 * Asgard Send Clearance Email
 * @param data The data for the request.
 * @param data.requestBody
 * @returns GeneratedPolicyNumbers Successful Response
 * @throws ApiError
 */
export const asgardSendClearanceEmail = (
  data: AsgardSendClearanceEmailData
): CancelablePromise<AsgardSendClearanceEmailResponse> => {
  return __request(OpenAPI, {
    method: "POST",
    url: "/asgard/send_clearance_email",
    body: data.requestBody,
    mediaType: "application/json",
    errors: {
      422: "Validation Error",
    },
  });
};
